import Loader from 'components/Shared/Loader';
import { useNotifications } from '../context';

export const Settings = () => {
  const { isTopicsLoaded, selectedTopics, toggleTopicSelection, topics, error, fcmToken } = useNotifications();

  if (!isTopicsLoaded || !fcmToken) {
    return <Loader />;
  }

  return (
    <>
      <p>Seleccioná las noticias sobre las que querés recibir alertas</p>
      <p>{error}</p>
      <div>
        {topics.map((topic) => {
          const isSelected = selectedTopics.includes(topic.slug);
          return (
            <button
              key={topic.slug}
              type="button"
              onClick={() => toggleTopicSelection(topic.slug, topic.name)}
              aria-pressed={isSelected}
              style={isSelected ? { background: '#e6e6e6' } : undefined}
            >
              {topic.name}
            </button>
          );
        })}
      </div>
    </>
  );
};
